import { combineReducers } from 'redux'
// @ts-ignore
import vcfDataReducer from './vcfDataReducer.ts'

export default combineReducers({
    vcfData: vcfDataReducer,
    // other reducers...
})